// @core/api/endpoints/authn/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { Authorize } from './authorize';
import { AuthorizeDevice } from './authorize_device';
import { CheckOIDCSession } from './check_oidc_session';
import { CreateOAuth2Client } from './create_oauth2_client';
import { CreateOAuth2Provider } from './create_oauth2_provider';
import { CreateSSOSession } from './create_sso_session';
import { DeleteOAuth2Client } from './delete_oauth2_client';
import { DeleteOAuth2Provider } from './delete_oauth2_provider';
import { DisableTwoFactorAuth } from './disable_two_factor_auth';
import { EnableTwoFactorAuth } from './enable_two_factor_auth';
import { EndOIDCSession } from './end_oidc_session';
import { ExchangeChannelToken } from './exchange_channel_token';
import { ExchangeDeviceToken } from './exchange_device_token';
import { ExchangeToken } from './exchange_token';
import { GetJWKS } from './get_jwks';
import { GetOAuth2Client } from './get_oauth2_client';
import { GetOAuth2Consent } from './get_oauth2_consent';
import { GetOAuth2Provider } from './get_oauth2_provider';
import { GetOpenIDConfiguration } from './get_open_id_configuration';
import { GetUserInfo } from './get_user_info';
import { GrantOAuth2Consent } from './grant_oauth2_consent';
import { HandleOAuth2Callback } from './handle_oauth2_callback';
import { InitiateOAuth2Flow } from './initiate_oauth2_flow';
import { IntrospectToken } from './introspect_token';
import { InvalidateAllTokens } from './invalidate_all_tokens';
import { InvalidateCurrentTokens } from './invalidate_current_tokens';
import { LinkOAuth2Account } from './link_oauth2_account';
import { ListLoginRecords } from './list_login_records';
import { ListOAuth2Clients } from './list_oauth2_clients';
import { ListOAuth2Connections } from './list_oauth2_connections';
import { ListOAuth2Consents } from './list_oauth2_consents';
import { ListOAuth2Providers } from './list_oauth2_providers';
import { ListPublicOAuth2Providers } from './list_public_oauth2_providers';
import { ListSSOSessions } from './list_sso_sessions';
import { RefreshTokens } from './refresh_tokens';
import { RequestPasswordReset } from './request_password_reset';
import { ResendVerificationEmail } from './resend_verification_email';
import { ResetPassword } from './reset_password';
import { RevokeOAuth2Consent } from './revoke_oauth2_consent';
import { RevokeToken } from './revoke_token';
import { RotateOAuth2ClientSecret } from './rotate_oauth2_client_secret';
import { SendOneTimeCode } from './send_one_time_code';
import { SendVerificationEmail } from './send_verification_email';
import { SignIn } from './sign_in';
import { SignInWithCode } from './sign_in_with_code';
import { SignUp } from './sign_up';
import { TerminateSSOSession } from './terminate_sso_session';
import { UnlinkOAuth2Account } from './unlink_oauth2_account';
import { UpdateOAuth2Client } from './update_oauth2_client';
import { UpdateOAuth2Provider } from './update_oauth2_provider';
import { UpdatePassword } from './update_password';
import { ValidateSSOSession } from './validate_sso_session';
import { VerifyEmail } from './verify_email';
import { VerifyPassword } from './verify_password';
import { VerifyTwoFactorAuth } from './verify_two_factor_auth';

// Re-export individual endpoints
export {
  Authorize,
  AuthorizeDevice,
  CheckOIDCSession,
  CreateOAuth2Client,
  CreateOAuth2Provider,
  CreateSSOSession,
  DeleteOAuth2Client,
  DeleteOAuth2Provider,
  DisableTwoFactorAuth,
  EnableTwoFactorAuth,
  EndOIDCSession,
  ExchangeChannelToken,
  ExchangeDeviceToken,
  ExchangeToken,
  GetJWKS,
  GetOAuth2Client,
  GetOAuth2Consent,
  GetOAuth2Provider,
  GetOpenIDConfiguration,
  GetUserInfo,
  GrantOAuth2Consent,
  HandleOAuth2Callback,
  InitiateOAuth2Flow,
  IntrospectToken,
  InvalidateAllTokens,
  InvalidateCurrentTokens,
  LinkOAuth2Account,
  ListLoginRecords,
  ListOAuth2Clients,
  ListOAuth2Connections,
  ListOAuth2Consents,
  ListOAuth2Providers,
  ListPublicOAuth2Providers,
  ListSSOSessions,
  RefreshTokens,
  RequestPasswordReset,
  ResendVerificationEmail,
  ResetPassword,
  RevokeOAuth2Consent,
  RevokeToken,
  RotateOAuth2ClientSecret,
  SendOneTimeCode,
  SendVerificationEmail,
  SignIn,
  SignInWithCode,
  SignUp,
  TerminateSSOSession,
  UnlinkOAuth2Account,
  UpdateOAuth2Client,
  UpdateOAuth2Provider,
  UpdatePassword,
  ValidateSSOSession,
  VerifyEmail,
  VerifyPassword,
  VerifyTwoFactorAuth,
};

// Namespace export for convenient usage
export const authnApi = {
  Authorize,
  AuthorizeDevice,
  CheckOIDCSession,
  CreateOAuth2Client,
  CreateOAuth2Provider,
  CreateSSOSession,
  DeleteOAuth2Client,
  DeleteOAuth2Provider,
  DisableTwoFactorAuth,
  EnableTwoFactorAuth,
  EndOIDCSession,
  ExchangeChannelToken,
  ExchangeDeviceToken,
  ExchangeToken,
  GetJWKS,
  GetOAuth2Client,
  GetOAuth2Consent,
  GetOAuth2Provider,
  GetOpenIDConfiguration,
  GetUserInfo,
  GrantOAuth2Consent,
  HandleOAuth2Callback,
  InitiateOAuth2Flow,
  IntrospectToken,
  InvalidateAllTokens,
  InvalidateCurrentTokens,
  LinkOAuth2Account,
  ListLoginRecords,
  ListOAuth2Clients,
  ListOAuth2Connections,
  ListOAuth2Consents,
  ListOAuth2Providers,
  ListPublicOAuth2Providers,
  ListSSOSessions,
  RefreshTokens,
  RequestPasswordReset,
  ResendVerificationEmail,
  ResetPassword,
  RevokeOAuth2Consent,
  RevokeToken,
  RotateOAuth2ClientSecret,
  SendOneTimeCode,
  SendVerificationEmail,
  SignIn,
  SignInWithCode,
  SignUp,
  TerminateSSOSession,
  UnlinkOAuth2Account,
  UpdateOAuth2Client,
  UpdateOAuth2Provider,
  UpdatePassword,
  ValidateSSOSession,
  VerifyEmail,
  VerifyPassword,
  VerifyTwoFactorAuth,
};
